import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

const initialKeyword = {
  MessageKeyWordID: 0,
  MessageKeyWord: "",
  FacilityID: 0,
  WebUserSentAction: "",
  WebUserSentActionID: 3,
  InmateSentAction: "",
  InmateSentActionID: 3,
  KeyWordFilterType: "",
  KeyWordFilterTypeID: 2,
  ActiveStatus: 1,
  EmailNotify: "",
  Action: 1,
  CreatedBy: 0,
};

const name = "keyword";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const keywordAction = { ...slice.actions, ...extraActions };
export const keywordReducer = slice.reducer;

function createInitialState() {
  return {
    keywordData: initialKeyword,
    searchKeyword: {
      MessageKeyWord: "",
      FacilityID: 0,
      WebUserSentAction: "-- ALL --",
      WebUserSentActionID: 3,
      InmateSentAction: "-- ALL --",
      InmateSentActionID: 3,
      KeyWordFilterType: "-- ALL --",
      KeyWordFilterTypeID: 2,
      ActiveStatus: 2,
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "",
    },
    facilityOpts: { loading: false, data: [] }, // Initialize as an object
    loadKeywordList: [],
    loadKeywordFullList: [],
    keywordDetails: [],
    replicateResponse: [],
    insertUpdateResponse: null,
    loading: false,
  };
}

function createReducers() {
  return {
    setKeywordData,
    resetkeyword,
    setfacilityOpts,
    resetfacilityOpts,
    clearexcelData,
    setSearchKeyword,
    clearSearchKeyword,
  };
  function setSearchKeyword(state, action) {
    state.searchKeyword = action.payload;
  }
  function clearSearchKeyword(state) {
    state.searchKeyword = {
      MessageKeyWord: "",
      FacilityID: 0,
      WebUserSentAction: "",
      WebUserSentActionID: 3,
      InmateSentAction: "",
      InmateSentActionID: 3,
      KeyWordFilterType: "",
      KeyWordFilterTypeID: 2,
      ActiveStatus: 2,
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "",
    };
  }
  function setKeywordData(state, action) {
    state.keywordData = action && action.payload;
  }
  function resetkeyword(state) {
    state.keywordData = initialKeyword;
  }
  function setfacilityOpts(state, action) {
    state.facilityOpts = action && action.payload;
  }
  function resetfacilityOpts(state) {
    state.facilityOpts = [];
  }
  function clearexcelData(state) {
    state.loadKeywordFullList = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/Keyword`;

  return {
    LoadKeywordList: LoadKeywordList(),
    GetKeywordInsertUpdate: GetKeywordInsertUpdate(),
    GetKeywordDetails: GetKeywordDetails(),
    LoadMessageKeyWordFacilityList: LoadMessageKeyWordFacilityList(),
    ReplicateKeyword: ReplicateKeyword(),
  };

  function LoadKeywordList() {
    return createAsyncThunk(`${name}/LoadKeywordList`, async (data) => {
      return await fetchWrapper.post(`${baseUrl}/LoadKeywordList`, data);
    });
  }

  function GetKeywordInsertUpdate() {
    return createAsyncThunk(`${name}/GetKeywordInsertUpdate`, async (data) => {
      return await fetchWrapper.post(`${baseUrl}/GetKeywordInsertUpdate`, data);
    });
  }

  function GetKeywordDetails() {
    return createAsyncThunk(`${name}/GetKeywordDetails`, async (id) => {
      return await fetchWrapper.get(
        `${baseUrl}/GetKeywordDetails?keywordID=${id}`
      );
    });
  }

  function LoadMessageKeyWordFacilityList() {
    return createAsyncThunk(
      `${name}/LoadMessageKeyWordFacilityList`,
      async (id) => {
        return await fetchWrapper.get(
          `${baseUrl}/LoadMessageKeyWordFacilityList?facilityID=${id}`
        );
      }
    );
  }

  function ReplicateKeyword() {
    return createAsyncThunk(`${name}/ReplicateKeyword`, async (param) => {
      return await fetchWrapper.post(`${baseUrl}/ReplicateKeyword`, param);
    });
  }
}

function createExtraReducers(builder) {
  builder
    //Grid data
    .addCase(extraActions.LoadKeywordList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadKeywordList.fulfilled, (state, action) => {
      state.loading = false;
      let params = action.meta.arg;

      if (params?.exportExcel) {
        state.loadKeywordFullList = action && action.payload;
      } else {
        state.loadKeywordList = action && action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.LoadKeywordList.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    })

    //InsertUpdate Response
    .addCase(extraActions.GetKeywordInsertUpdate.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetKeywordInsertUpdate.fulfilled, (state, action) => {
      state.insertUpdateResponse = action && action.payload;
      state.loading = false;
    })
    .addCase(extraActions.GetKeywordInsertUpdate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //get the keywordDetail Using Id
    .addCase(extraActions.GetKeywordDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetKeywordDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.keywordDetails = action && action.payload;
    })
    .addCase(extraActions.GetKeywordDetails.rejected, (state, action) => {
      state.error = false;
      state.error = action.error.message;
    })

    //Get facility dropDownList
    .addCase(extraActions.LoadMessageKeyWordFacilityList.pending, (state) => {
      state.facilityOpts.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadMessageKeyWordFacilityList.fulfilled,
      (state, action) => {
        state.facilityOpts.loading = false;
        state.facilityOpts.data = action && action.payload;
      }
    )
    .addCase(
      extraActions.LoadMessageKeyWordFacilityList.rejected,
      (state, action) => {
        state.facilityOpts.loading = false;
        state.error = action.error.message;
      }
    )

    //ReplicateKeyword
    .addCase(extraActions.ReplicateKeyword.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.ReplicateKeyword.fulfilled, (state, action) => {
      state.loading = false;
      state.replicateResponse = action && action.payload;
    })
    .addCase(extraActions.ReplicateKeyword.rejected, (state, action) => {
      state.error = false;
      state.error = action.error.message;
    });
}
